"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var UIUtils_1 = require("../../../shared/modules/UIUtils");
var BaseController_1 = require("../../../shared/controllers/BaseController");
var webAApi_1 = require("../../api/webAApi");
var moment = require("moment");
var AdminsAccessUsrPermissionsCtl = /** @class */ (function (_super) {
    __extends(AdminsAccessUsrPermissionsCtl, _super);
    function AdminsAccessUsrPermissionsCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_obtain_admin_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.obtain_admin_login; });
        _this.dk_grant_admin_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.grant_admin_login; });
        _this.dk_usr_permission_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_permission_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    AdminsAccessUsrPermissionsCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: [],
        };
    };
    AdminsAccessUsrPermissionsCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    AdminsAccessUsrPermissionsCtl.prototype.LoadDataByUsrPermissionId = function (usrPermissionId, onDone) {
        var _this = this;
        webAApi_1.ListAdminAccessByUsrPermissionId.exec({ usr_permission_id: usrPermissionId }, function (resp) {
            _this.DATA.data = [];
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    obtain_admin_login: resp.list[i].obtain_admin_login,
                    grant_admin_login: resp.list[i].grant_admin_login,
                    usr_permission_title: resp.list[i].usr_admin_permission_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AdminsAccessUsrPermissionsCtl.prototype.LoadDataByObtainAdminId = function (adminId, onDone) {
        var _this = this;
        webAApi_1.ListAllowedUsrPermissionsByObtainAdminIdGet.exec({ obtain_usr_admin_id: adminId }, function (resp) {
            _this.DATA.data = [];
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    grant_admin_login: resp.list[i].grant_admin_login,
                    obtain_admin_login: resp.list[i].obtain_admin_login,
                    usr_permission_title: resp.list[i].usr_admin_permission_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AdminsAccessUsrPermissionsCtl.prototype.LoadDataByGrantAdminId = function (adminId, onDone) {
        var _this = this;
        webAApi_1.ListAllowedUsrPermissionsByGrantAdminIdGet.exec({ grant_usr_admin_id: adminId }, function (resp) {
            _this.DATA.data = [];
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    grant_admin_login: resp.list[i].grant_admin_login,
                    obtain_admin_login: resp.list[i].obtain_admin_login,
                    usr_permission_title: resp.list[i].usr_admin_permission_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AdminsAccessUsrPermissionsCtl.prototype.DoAddAccess = function (usrPermissionId, adminId, onDone) {
        var _this = this;
        webAApi_1.DoAddUsrPermissionAdminAccess.exec({
            data: {
                usr_admin_permission_id: usrPermissionId,
                usr_admin_id: adminId
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                grant_admin_login: resp.grant_admin_login,
                obtain_admin_login: resp.obtain_admin_login,
                usr_permission_title: resp.usr_admin_permission_title,
                date_added: moment(resp.date_added_uts_ms).utc(false)
            });
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AdminsAccessUsrPermissionsCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AdminsAccessUsrPermissionsCtl.prototype.DoDeleteAccess = function (accessKey, onDone) {
        var _this = this;
        var _tmp = this.getById(accessKey);
        if (_tmp) {
            webAApi_1.DoDeleteUsrPermissionAdminAccess.exec({ data: { usr_permission_admin_access_id: accessKey } }, function (resp) {
                _this.RemoveItem(accessKey);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AdminsAccessUsrPermissionsCtl;
}(BaseController_1.BaseController));
exports.AdminsAccessUsrPermissionsCtl = AdminsAccessUsrPermissionsCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/shared/controllers/AdminsAccessUsrPermissionsCtl.ts
// module id = 2162
// module chunks = 0